/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const analyticsModule = require('@utils/analytics/analyticsModule');
const cmsModule = require('@utils/cms/cmsModule');
const commonModule = require('@utils/common/commonModule');
const filtersModule = require('@utils/filters/filtersModule');
const CategoryGuideModalService = require('./categoryGuideModalService');
const categoryGuideModalDirective = require('./categoryGuideModalDirective');

const categoryGuideModule = angular
    .module('enervee_utils.category_guide', [
        analyticsModule.name,
        cmsModule.name,
        commonModule.name,
        filtersModule.name,
    ])
    .factory('CategoryGuideModalService', CategoryGuideModalService)
    .directive('categoryGuideModal', categoryGuideModalDirective);

module.exports = categoryGuideModule;
